<script lang="ts">
    import { t } from "@lernetz/svelte-translate";
    import { createEventDispatcher } from "svelte";
    import { setupSharedProps, sharedProps } from "../../../setup";

    export let formData;

    setupSharedProps();

    formData.lang = sharedProps.currentLocale ?? 'de';


    const dispatch = createEventDispatcher();

    $: isValid = formData.name.trim().length >= 4 && !!formData.cycle;

</script>

<div class="bg-white w-full max-w-580 p-24 md:p-48 rounded-3xl md:min-h-[672px] flex flex-col max-h-[calc(100dvh-6rem)] md:max-h-[calc(100dvh-3rem)] overflow-y-auto">
    <div class="font-Caveat text-blue-main text-36 md:text-54 text-center font-bold">
        {$t('knowledge query')}
    </div>
    <div class="text-18 mt-24 md:mt-32">
        {$t('Select the topic you will be covering with your class and name your dashboard.')}
    </div>
    <div class="flex flex-col sm:flex-row gap-12 sm:gap-16 mt-24 md:mt-32">
        <div class="flex flex-col grow">
          <label for="name" class="size-14 text-grey-1 w-full">
            {$t('dashboard name (min. 4 characters)')}
          </label>
          <input id="name" type="text" placeholder={$t('enter name')} bind:value={formData.name} class="mt-10 border-blue-light border-2 rounded-lg text-18 px-16 py-8 h-48"/>
        </div>
      </div>
      <div class="mt-24 md:mt-48 grid grid-cols-1 sm:grid-cols-2 gap-12 sm:gap-24">
        <button class="{formData.cycle == 'cycle1' ? 'bg-yellow-main text-white' : 'text-yellow-main bg-white'} border-yellow-main border-2 rounded-lg px-14 pt-12 pb-20" on:click={() => formData.cycle = "cycle1"}>
            <div class="text-22 font-bold">
                {$t('Fire and fire prevention')}
            </div>
            <div class="">
                {$t('cycle 1')}
            </div>
        </button>
        <button class="{formData.cycle == 'cycle2' ? 'bg-green-main text-white' : 'text-green-main bg-white'} border-green-main border-2 rounded-lg px-14 pt-12 pb-20" on:click={() => formData.cycle = "cycle2"}>
            <div class="text-22 font-bold">
                {$t('Weather and natural hazards')}
            </div>
            <div class="">
                {$t('cycle 2')}
            </div>
        </button>
      </div>
      <button disabled={!isValid} on:click={() => dispatch('next')} class="{!isValid ? 'bg-blue-light' : 'bg-blue-main hover:bg-blue-hover'} px-24 py-10 rounded-md text-white w-fit mt-48 md:mt-auto mx-auto">{$t('next')}</button>
</div>
